import React from "react";
import {useLocation} from "react-router-dom";
import "./conditions-block.css";
import Routes from "../../assets/RoutesToPages/Routes";

const ConditionsBlock = ({handleRedirectToTerm}) => {
  const location = useLocation();
  const locationPath = location.pathname;

  const applySuitableStyle = () => {
    return locationPath === Routes.userProfileUpdated ||
    locationPath === Routes.userProfile ? 'conditions-block__terms' : 'conditions-block__terms--unsubscription';
  }

  return (
    <div className='conditions-block'>
      <a className={applySuitableStyle()}
         data-terms='terms'
         onClick={handleRedirectToTerm}>
        UŽIVATELSKÉ PODMÍNKY
      </a>

      {locationPath === Routes.userProfileUpdated ||
      locationPath === Routes.userProfile ||
      locationPath === Routes.unsubscription
        ?
        <a className={applySuitableStyle()}
           data-terms='policy'
           onClick={handleRedirectToTerm}>
          ZÁSADY OCHRANY OSOBNÝCH ÚDAJOV
        </a>
        :
        null}

      {locationPath === Routes.userProfileUpdated ||
      locationPath === Routes.userProfile ||
      locationPath === Routes.unsubscriptionSuccess
        ?
        <a className={applySuitableStyle()}
           data-terms='help'
           onClick={handleRedirectToTerm}>
          POMOC
        </a>
        :
        null}

      {locationPath === Routes.userProfileUpdated ||
      locationPath === Routes.userProfile ||
      locationPath === Routes.unsubscriptionSuccess
        ?
        <>
          {locationPath === Routes.userProfileUpdated ||
          locationPath === Routes.userProfile
            ?
            <span className='divider'>|</span>
            :
            null}
          <a className={applySuitableStyle()}
             data-terms='about'
             onClick={handleRedirectToTerm}>
            O aplikácii
          </a>
        </>
        : null}

      {locationPath === Routes.userProfileUpdated ||
      locationPath === Routes.userProfile
        ?
        <>
          <span className='divider'>|</span>
          <a className={applySuitableStyle()}
             data-terms='unsubscription'
             onClick={handleRedirectToTerm}>
            ZRUŠIŤ
          </a>
        </>
        :
        null}
    </div>
  )
}

export default ConditionsBlock;